import { defineStore, storeToRefs } from 'pinia'
import { getThemeMode, getThemeType, getSystemThemeMode, themeTypeValueToNameMap } from '@ms/utils/theme'
import { useGlobalConfigStore } from '@ms/stores/globalConfig'
import { THEME_TYPE } from '@ms/config/theme'

const isUIThemeOnline = process.env.VUE_APP_UI_THEME_ONLINE

export const useSettingStore = defineStore('setting', {
  state: () => ({
    // 是否显示切换国家弹窗
    visibleRegionBox: false,
    themeMode: isUIThemeOnline ? getThemeMode() : 2,
    themeType: isUIThemeOnline ? getThemeType() : 0,
    systemThemeMode: isUIThemeOnline ? getSystemThemeMode() : null
  }),
  actions: {
    toggleRegionBox(status = false) {
      this.visibleRegionBox = status
    },
    setThemeMode(mode) {
      if (!isUIThemeOnline) return
      this.themeMode = mode
      localStorage.setItem('themeMode', mode)
    },
    setThemeType(type) {
      if (!isUIThemeOnline) return
      this.themeType = type
      localStorage.setItem('themeType', type)
    },
    setSystemThemeMode(mode) {
      if (!isUIThemeOnline) return
      this.systemThemeMode = mode
      localStorage.setItem('systemThemeMode', mode)
    },
    /**
     * Check if current theme type is enabled in the config
     */
    isThemeTypeEnabled() {
      if (!isUIThemeOnline) return false
      const themeTypeName = themeTypeValueToNameMap.value.get(this.themeType)
      const { config } = storeToRefs(useGlobalConfigStore())

      if (themeTypeName in config.value) {
        const enabled = config.value[themeTypeName]
        return enabled
      }

      return false
    },
    /**
     * Sync theme type with config
     */
    syncThemeTypeWithConfig() {
      if (!isUIThemeOnline) return
      if (!this.isThemeTypeEnabled()) {
        this.setThemeType(THEME_TYPE.DEFAULT.value)
      }
    }
  }
})
